import { BrowserRouter, Route, Routes } from 'react-router-dom';
import React, { useEffect } from 'react';
import { AuthProvider } from './screens/auth/2fa/auth.js';
import { RequireAuth } from './screens/auth/2fa/RequireAuth.js';
import {
  getUser,
  getToken,
  setUserSession,
  resetUserSession,
} from './screens/auth/2fa/AuthService.js';
import axios from 'axios';
import {
  LoginAsSeller,
  Register,
  Login,
  UserProfile,
  DashboardLayout,
  Layout,
  CreateCategory,
  UpdateCategory,
  Catgeorylist,
  UpdateProductByAdmin,
  AdminProductList,
  Income,
  Dashboard,
  ProductList,
  ProductEdit,
  AddProduct,
  ProductsDetailsPage,
  Home,
  UserList,
  WinningBidList,
  NotFound,
  ScrollToTop,
  PrivateRoute,
  TwoFa,
  Count,
  ScheduleUpload,
  CountUpload,
} from './router/index.js';

function App() {
  const verify = async (e) => {
    const token = getToken();
    if (
      token === 'undefined' ||
      token === undefined ||
      token === null ||
      !token
    ) {
      return;
    }
    const hed = {
      headers: {
        authorization: `Bearer ${token}`,
      },
    };
    let res = await axios
      .get(`${process.env.REACT_APP_API_URL}verify-token`, hed)
      .then((response) => {
        console.log(response);
        setUserSession(getUser(), token);
      })
      .catch((error) => {
        resetUserSession();
        console.log(error);
      });
  };
  useEffect(() => {
    verify();
  }, []);
  return (
    <>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route
              path='/'
              element={
                <Layout>
                  <Home />
                </Layout>
              }
            />

            <Route
              path='/login'
              element={
                <Layout>
                  <Login />
                </Layout>
              }
            />

            <Route
              path='/2fa'
              element={
                <RequireAuth>
                  <TwoFa />
                </RequireAuth>
              }
            />

            {localStorage.getItem('_id') == '253876F1A' && (
              <>
                <Route
                  path='/dashboard'
                  element={
                    <RequireAuth>
                      <Layout>
                        <DashboardLayout>
                          <Dashboard />
                        </DashboardLayout>
                      </Layout>
                    </RequireAuth>
                  }
                />

                <Route
                  path='/add'
                  element={
                    <RequireAuth>
                      <Layout>
                        <DashboardLayout>
                          <AddProduct />
                        </DashboardLayout>
                      </Layout>
                    </RequireAuth>
                  }
                />

                <Route
                  path='/hutch-message-count'
                  element={
                    <RequireAuth>
                      <Layout>
                        <DashboardLayout>
                          <Count />
                        </DashboardLayout>
                      </Layout>
                    </RequireAuth>
                  }
                />

                <Route
                  path='/userlist'
                  element={
                    <RequireAuth>
                      <Layout>
                        <DashboardLayout>
                          <UserList />
                        </DashboardLayout>
                      </Layout>
                    </RequireAuth>
                  }
                />
                <Route
                  path='/schedule-upload'
                  element={
                    <RequireAuth>
                      <Layout>
                        <DashboardLayout>
                        <ScheduleUpload/>
                        </DashboardLayout>
                      </Layout>
                    </RequireAuth>
                  }
                />
                <Route
                  path='/count-upload'
                  element={
                    <RequireAuth>
                      <Layout>
                        <DashboardLayout>
                          <CountUpload/>
                        </DashboardLayout>
                      </Layout>
                    </RequireAuth>
                  }
                />

                {/* hutch-message-count */}
              </>
            )}
            <Route
              path='/*'
              element={
                <Layout>
                  <NotFound />
                </Layout>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </>
  );
}

export default App;
